export const validatorAll = (string) => {
  return string.length >= 8 && /\d.*\d/.test(string) && /[A-Z]/.test(string) && /[a-z]/.test(string) && /[!@#$%^&*(),.?":{}|<>]/.test(string)
}

export const validadeLength = (string) => string.length >= 8
export const validadeNumbers = (string) => /\d.*\d/.test(string)
export const validadeUpperCase = (string) => /[A-Z]/.test(string)
export const validadeLowerCase = (string) => /[a-z]/.test(string)
export const validadeCharacter = (string) => /[!@#$%^&*(),.?":{}|<>]/.test(string)
